<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="this.isLoaded" :caption="this.isLoaded ? 'Кратко' : 'Подробно'" :expandable="true">
      <div
        v-show="isLoading"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-show="!isLoading">
        <div v-if="reg"> Регистрация: {{formatDate(reg.regDate)}}</div>

        Постановка на учет:        
        <div v-if="tax"> Налоговая служба с {{formatDate(tax.regDate)}}</div>
        <div v-if="pf"> Пенсионный фонд с {{formatDate(pf.regDate)}}</div>
        <div v-if="fss"> Фонд Социального Страхования с {{formatDate(fss.regDate)}}</div>
      </div>  
    </v-panel-title>
    <v-card-text v-show="isLoaded" class="pt-0">
      <div v-if="reg">
        Регистрация:
        <v-flex pl-2> 
          <component :is="createTaxOfficeComp(reg.authority)"/>
          <div>
            <component :is="renderValueLink(formats.blank(reg.number), 'Номер:', null, 'Копировать номер')"/>
          </div>
          <div>
            <component :is="renderValueLink(formats.blank(formatDate(reg.regDate)), 'Дата регистрации:', null, 'Копировать дату')"/>
          </div>
        </v-flex>
      </div>      
      <div v-if="tax">
        Налоговая служба:
        <v-flex pl-2> 
          <component :is="createTaxOfficeComp(tax.authority)"/>
          <div>
            <component :is="renderValueLink(formats.blank(tax.inn), 'ИНН:', null, 'Копировать ИНН')"/>
            <component :is="renderValueLink(formats.blank(tax.kpp), 'КПП:', null, 'Копировать КПП')"/>
          </div>
          <div>
            <component :is="renderValueLink(formats.blank(formatDate(tax.regDate)), 'Дата постановки на учет:', null, 'Копировать дату')"/>
          </div>
        </v-flex>  
      </div>
      <div v-if="pf">
        Пенсионный фонд:
        <v-flex pl-2> 
          <component :is="createTaxOfficeComp(pf.authority)"/>
          <div>
            <component :is="renderValueLink(formats.blank(pf.number), 'Номер:', null, 'Копировать номер')"/>
          </div>
          <div>
            <component :is="renderValueLink(formats.blank(formatDate(pf.regDate)), 'Дата постановки на учет:', null, 'Копировать дату')"/>
          </div>
        </v-flex>  
      </div>
      <div v-if="fss">
        Фонд Социального Страхования:
        <v-flex pl-2> 
          <component :is="createTaxOfficeComp(fss.authority)"/>
          <div>
            <component :is="renderValueLink(formats.blank(fss.number), 'Номер:', null, 'Копировать номер')"/>
          </div>
          <div>
            <component :is="renderValueLink(formats.blank(formatDate(fss.regDate)), 'Дата постановки на учет:', null, 'Копировать дату')"/>
          </div>
        </v-flex>
      </div>
    </v-card-text>

  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import vPanelTitle from './PanelTitle'
  import formats from '../../api/formats'
  import apimix from '../common/apimix'

  export default {
    name: 'v-credentinals-panel',
    components: {vPanelTitle},
    mixins: [apimix],
    data: () => ({
      id: null,
      isLoaded: false,
      isLoading: false,
      topCount: 1
    }),
    props: {
      fillHeight: {
        type: Boolean,
        default: false
      },
      reg: null,
      tax: null,
      pf: null,
      fss: null
    },
    watch: {
    },
    computed: {
      ...mapGetters({
        renderValueLink: 'renderValueLink'
      }),
      topItems () {
        return this.items.slice(0, this.topCount)
      },
      lastItems () {
        return this.items.slice(this.topCount)
      },
      items () {
        return []
      }
    },
    methods: {
      switchItems () {
        this.isLoaded = !this.isLoaded
      },
      formatDate (dateTime) {
        return formats.blank(dateTime, formats.formatDate)
      },
      createTaxOfficeComp (taxOffice) {
        console.log('createTaxOfficeComp', taxOffice)
        var self = this
        var template = ''.concat(
          `<div>              
              <div v-if="dto && dto.name">
                <component :is="self.renderValueLink(self.formats.blank(dto.name) , null, null, 'Копировать название')"/>
              </div>
              <div v-if="dto && dto.code">
                <component :is="self.renderValueLink(dto.code, 'Код подразделения:', null, 'Копировать код')"/>
              </div>
              <div v-if="dto && dto.address">
              <component :is="self.renderValueLink(dto.address , 'Адрес:', null, 'Копировать адрес')"/>
              </div>
           </div>`
        )
        return {
          template: template,
          data: function () {
            return {
              self: self,
              dto: taxOffice
            }
          }
        }
      }
    }
  }

</script>


// WEBPACK FOOTER //
// CredentinalsPanel.vue?95644d3a